import { useMemo } from 'react';

export function useVirtualItems({ positions, scrollTop, viewportHeight, overscanPx = 1200, pinnedIdsSet }) {
  return useMemo(() => {
    const topBound = Math.max(0, scrollTop - overscanPx);
    const bottomBound = scrollTop + viewportHeight + overscanPx;

    const visible = [];

    for (const p of positions) {
      const itemTop = p.top;
      const itemBottom = p.top + (p.usedHeight || 0);

      const isPinned = pinnedIdsSet?.has(p.id);
      const inView = itemBottom >= topBound && itemTop <= bottomBound;

      if (isPinned || inView) visible.push(p.id);
    }

    return new Set(visible);
  }, [positions, scrollTop, viewportHeight, overscanPx, pinnedIdsSet]);
}
